import React, {createContext, ReactNode, useCallback, useContext, useMemo, useState} from 'react';
import RulesModal from '../components/rules/RulesModal';

interface RulesModalContextType {
    openRulesModal: () => void;
    closeRulesModal: () => void;
    isRulesModalOpen: boolean;
}

const RulesModalContext = createContext<RulesModalContextType | undefined>(undefined);

interface RulesModalProviderProps {
    children: ReactNode;
}

export function RulesModalProvider({children}: RulesModalProviderProps): JSX.Element {
    const [isRulesModalOpen, setIsRulesModalOpen] = useState(false);

    const openRulesModal = useCallback((): void => {
        setIsRulesModalOpen(true);
    }, []);

    const closeRulesModal = useCallback((): void => {
        setIsRulesModalOpen(false);
    }, []);

    const value = useMemo(
        () => ({
            openRulesModal,
            closeRulesModal,
            isRulesModalOpen,
        }),
        [openRulesModal, closeRulesModal, isRulesModalOpen]
    );

    return (
        <RulesModalContext.Provider value={value}>
            {children}
            <RulesModal isOpen={isRulesModalOpen} onClose={closeRulesModal} />
        </RulesModalContext.Provider>
    );
}

export function useRulesModal(): RulesModalContextType {
    const context = useContext(RulesModalContext);
    if (context === undefined) {
        throw new Error('useRulesModal must be used within a RulesModalProvider');
    }
    return context;
}
